import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import decimal from 'decimal.js';
import { Item } from 'MonadomCoreUI';
import { SelectSessionButton } from './KeysAndSigningUI';
import { TextLine3, ForDevelopment } from './UtilComponents';
import {
  handleClickGoTop,
  handleClickGoBack,
  handleClickCheckOut,
} from './monadomCore';
import { useGlobalStateSelector, words } from './globalState';
import { getValidKeyPairs } from './keysAndSigning';
import {
  handleClickGetRegisteredItem,
  addToCart,
  removeFromCart,
  handleClickSubmitOrder,
  handleClickGetItemOrderHistory,
} from './purchaseItem';
import { localTime } from './utils';
import imageCardShopTitle from './cardShopTitle.png';
import iconCircleLeft from './arrow_circle_left_FILL0_wght400_GRAD0_opsz48.svg';
import iconCircleRight from './arrow_circle_right_FILL0_wght400_GRAD0_opsz48.svg';
import iconSearch from './search_FILL0_wght400_GRAD0_opsz48.svg';
import iconDetail from './more_horiz_FILL0_wght400_GRAD0_opsz48.svg';
import iconSign from './history_edu_FILL0_wght400_GRAD0_opsz48.svg';

// PURCHASE ITEM
function PurchaseItem() {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);
  const location = useLocation();
  let items;
  let itemFunction;
  let arrowLeft;
  let arrowRight;

  useEffect( () => {
     handleClickGetRegisteredItem(state, dispatch, 0);
  }, []);

  // アクションごとのitemsとitemFunction設定。

  if (state.getRegisteredItem.action === 'registeredItemAll') {
    if (state.registeredItemAll.registeredItem !== undefined) {
      items = state.registeredItemAll.registeredItem.map( item => <Merchandise item={item} /> );

      // items.unshift(<DuelRecordTitle />);
    }
    else {
      // items = [<DuelRecordTitle />];
    }

    itemFunction = (pagingIndex) => handleClickGetRegisteredItem(state, dispatch, pagingIndex);
  }

  // 矢印

  if ( state.getRegisteredItem.pagingIndex[state.getRegisteredItem.action] >= 1 ) {
    arrowLeft = <div>
      <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large backgroundColorTransparent borderNone cursor borderRadiusCircle riseOut2 '
        onClick={ () => itemFunction(state.getRegisteredItem.pagingIndex[state.getRegisteredItem.action] - 1) }
      >
        <img className='size2x2' src={iconCircleLeft} alt='left' />
      </button>
    </div>
  }
  else {
    arrowLeft = <div>
      <button className='size2x2Large backgroundColorTransparent borderNone' disabled={true} >
        <div className='size2x2' />
      </button>
    </div>
  }

  if ( state.getRegisteredItem.lastEvaluatedKey[state.getRegisteredItem.action][state.getRegisteredItem.pagingIndex[state.getRegisteredItem.action]] !== undefined &&
       state.getRegisteredItem.lastEvaluatedKey[state.getRegisteredItem.action][state.getRegisteredItem.pagingIndex[state.getRegisteredItem.action]] !== null         ) {
    arrowRight = <div>
      <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large backgroundColorTransparent borderNone cursor borderRadiusCircle riseOut2 '
        onClick={ () => { itemFunction(state.getRegisteredItem.pagingIndex[state.getRegisteredItem.action] + 1) } }
      >
        <img className='size2x2' src={iconCircleRight} alt='right' />
      </button>
    </div>
  }
  else {
    arrowRight = <div>
      <button className='size2x2Large backgroundColorTransparent borderNone' disabled={true} >
        <div className='size2x2' />
      </button>
    </div>
  }

  const headerFixed =
  <div className='z200FixedZero widthMax backgroundColorWhiteTransparent '>
    <div className='flexRow justifyContentSpaceBetween marginBottom1' >
      <button className='button2' onClick={ () => handleClickCheckOut(state, dispatch, navigate, { previousLocation: 'purchaseitems' }) }>
        { words.checkout[state.language] }
      </button>
      <button className='button2' onClick={ () => handleClickGoBack(state, dispatch, navigate, location) }>
        { words.back[state.language] }
      </button>
    </div>
  </div>;

  const headerRelative =
  <div className='widthMax height6 ' >
  </div>;


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore flexColumn alignItemsCenter">
        { headerRelative }
        <img className='width80' src={imageCardShopTitle} alt='card shop' />
        <div className='flexRow justifyContentFlexStart alignItemsCenter marginTopBottom1 '>
          <button className='button1' tabindex='0' onClick={ () => itemFunction(0) } >
            <img className='size2x2' src={iconSearch} alt='search' />
          </button>
          { arrowLeft }
          { arrowRight }
        </div>
        <div className="textCenter marginSide1 marginBottom1">
          { words.cardsSoldHereAreOfficialReplicas[state.language] }
        </div>
        <div className="flexRow justifyContentSpaceAround ">
            { items }
        </div>
      </div>
      {/* SP */}
      <div className="flexColumn visibleSmallOrLess ">
        { headerRelative }
        <img className='widthMax' src={imageCardShopTitle} alt='card shop' />
        <div className='flexRow alignItemsCenter marginSide1 marginTopBottom1 '>
          <button className='button1' tabindex='0' onClick={ () => itemFunction(0) } >
            <img className='size2x2' src={iconSearch} alt='search' />
          </button>
          { arrowLeft }
          { arrowRight }
        </div>
        <div className="textCenter marginSide1 marginBottom1">
          { words.cardsSoldHereAreOfficialReplicas[state.language] }
        </div>
        <div className="flexRow justifyContentFlexStart">
            { items }
        </div>
      </div>
      { headerFixed }
    </div>
  );
}

// MERCHANDISE
function Merchandise(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const item = props.item;

  let amountToBuy;

  if (state.checkout.itemsIncart[item.itemNo] !== undefined) {
    amountToBuy = state.checkout.itemsIncart[item.itemNo].amountToBuy;
  }
  else {
    amountToBuy = 0;
  }


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <div className='flexRow justifyContentCenter alignItemsCenter boxShadow01 margin1'>
          <MerchandiseImage item={item} />
          <div className='flexColumn justifyContentFlexStart alignItemsCenter'>
            <MerchandiseName item={item} />
            <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 marginTop0p5 '>
              <div>
                { words.unitPriceJpy[state.language] }
              </div>
              <div className='marginSide1' >
                { item.priceJpy.toLocaleString() }
              </div>
              <div>
                { words.yen[state.language] + words.taxIncluded[state.language] }
              </div>
            </div>
            <MerchandiseStock item={item} />
            <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
              <div>
                { words.addToYourCart[state.language] }
              </div>
              <AddToCartButtons item={item} word={amountToBuy} />
            </div>
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="flexColumn visibleSmallOrLess ">
        <div className='flexColumn justifyContentFlexStart alignItemsCenter width96vw marginBottom2 boxShadow01'>
          <MerchandiseImage item={item} />
          <MerchandiseName item={item} />
          <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 marginTop0p5 '>
            <div>
              { words.unitPriceJpy[state.language] }
            </div>
            <div className='marginSide1' >
              { item.priceJpy.toLocaleString() }
            </div>
            <div>
              { words.yen[state.language] + words.taxIncluded[state.language] }
            </div>
          </div>
          <MerchandiseStock item={item} />
          <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
            <div>
              { words.addToYourCart[state.language] }
            </div>
            <AddToCartButtons item={item} word={amountToBuy} />
          </div>
        </div>
      </div>
    </div>
  );
}

// MERCHANDISE IMAGE
function MerchandiseImage(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const item = props.item;
  const popupLayerNext = props.popupLayer !== undefined && props.popupLayer !== null ? props.popupLayer + 1 : 0;

  let itemImageBox;

  if (item.itemImage?.type === 'subItem') {
    const cardImageUrl = `https://${process.env.REACT_APP_MONACARD_URL}small/${item.subItems[item.itemImage.indexCard].asset}_small.png`;

    itemImageBox =
    <div className='flexRow itemImage' >
      <div className='itemImageSingleCard' >
        <img className='width96PC' src={cardImageUrl} alt=''/>
      </div>
      <div className='flexColumn justifyContentCenter alignItemsCenter itemImageSingleCard ' >
        <div className='' >
          { words.monatokaPoint[state.language] }
        </div>
        <div className='' >
          { `${item.subItems[item.itemImage.indexMonatokaPoint].amount} ${words.point[state.language]}` }
        </div>
        <div className='' >
          { words.included[state.language] }
        </div>
      </div>
    </div>;
  }
  else {
    const cardImageUrl = `https://${process.env.REACT_APP_KOM_ITEMIMAGE_URL}item${item.itemNo.toString().padStart(6, '0')}.png`;
    // const cardImageUrlSP = `https://${process.env.REACT_APP_KOM_ITEMIMAGE_URL}item${item.itemNo.toString().padStart(6, '0')}.png`;

    itemImageBox = <img className='itemImage' src={cardImageUrl} alt='cardimage' />;
  }

  return (
    <button className='backgroundColorTransparent borderNone cursor ' disabled={props.disabled ? true : false}
      onClick={ () => {
        const body = item;
        const popup = { type: 'merchandiseDetail', body: body };
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
      }}
    >
      <div className='relative' >
        { itemImageBox }
        {/* <img className='itemImage' src={cardImageUrl} /> */}
        {/* screen */}
        {/* soldOut */}
      </div>
    </button>
  );
}

// MERCHANDISE NAME
function MerchandiseName(props) {
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const item = props.item;
  const popupLayerNext = props.popupLayer !== undefined && props.popupLayer !== null ? props.popupLayer + 1 : 0;

  return (
    <button className='backgroundColorUp backgroundColorTransparent borderLink fontHyperLink margin0p5 boxShadow01 cursor' disabled={props.disabled ? true : false}
      onClick={ () => {
        const body = item;
        const popup = { type: 'merchandiseDetail', body: body };
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
      }}
    >
      { item.name }
    </button>
  );
}

// MERCHANDISE STOCK
function MerchandiseStock(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const item = props.item;

  let stock;

  if (item.displayStock === 'normal') { // else none
    stock =
    <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
      <div>
        { words.stock[state.language] }
      </div>
      <div className='marginSide1' >
        { item.stock.toLocaleString() }
      </div>
      <div>
        { words.ko[state.language] }
      </div>
    </div>;
  }

  return stock;
}

// MERCHANDISE DETAIL
function MerchandiseDetail(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const item = state.popup[props.popupLayer].body;
  const subItemsAll = item.subItems;

  let subItems = {};
  let cardSection;
  let pointSection;

  subItems.card = subItemsAll
  .filter( item => item.type === 'card' )
  .sort( (a, b) => a.subItemNo - b.subItemNo )
  .map ( item => <Item item={item} size='small' popupLayer={props.popupLayer} quantity={false} arrows={false} />);

  if (subItems.card.length >= 1) {
    cardSection =
    <div>
      <div className='flexRow justifyContentFlexStart alignItemsCenter marginBottom1'>
        { words.card[state.language] }
      </div>
      <div className='flexRow justifyContentFlexStart alignItemsCenter marginBottom1'>
        { subItems.card }
      </div>
    </div>;
  }

  subItems.point = subItemsAll
  .filter( item => item.type === 'monatokaPoint' )[0];

  if (subItems.point !== undefined) {
    pointSection =
    <div>
      <div className='flexRow justifyContentFlexStart alignItemsCenter marginBottom1'>
        { words.monatokaPoint[state.language] }
      </div>
      <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
        <div className='marginSide1'>
          { subItems.point.amount.toLocaleString() }
        </div>
        <div>
          { words.point[state.language] }
        </div>
      </div>
    </div>;
  }


  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='flexColumn justifyContentFlexStart alignItemsFlexStart '>
          <div className='flexRow justifyContentFlexStart alignItemsCenter borderBottom marginBottom1'>
            { item.name }
          </div>
          <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
            <div>
              { words.unitPriceJpy[state.language] }
            </div>
            <div className='marginSide1' >
              { item.priceJpy.toLocaleString() }
            </div>
            <div>
              { words.yen[state.language] + words.taxIncluded[state.language] }
            </div>
          </div>
          <MerchandiseStock item={item} />
          <div className='padding0p5 '>
            { cardSection }
          </div>
          <div className='padding0p5 '>
            { pointSection }
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='flexColumn justifyContentFlexStart alignItemsFlexStart marginSide1 '>
          <div className='flexRow justifyContentFlexStart alignItemsCenter borderBottom marginBottom1'>
            { item.name }
          </div>
          <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
            <div>
              { words.unitPriceJpy[state.language] }
            </div>
            <div className='marginSide1' >
              { item.priceJpy.toLocaleString() }
            </div>
            <div>
              { words.yen[state.language] + words.taxIncluded[state.language] }
            </div>
          </div>
          <MerchandiseStock item={item} />
          <div className='padding0p5 '>
            { cardSection }
          </div>
          <div className='padding0p5 '>
            { pointSection }
          </div>
        </div>
      </div>
    </div>
  );
}

// MERCHANDISE IN CART
function MerchandiseInCart(props) {
  const state = useGlobalStateSelector(({ state }) => state);

  const itemInCart = props.itemInCart;
  // const itemInformation = state.registeredItemAll

  if (itemInCart.amountToBuy <= 0) {
    return null;
  }

  const priceJpyDecimal = new decimal(itemInCart.information.priceJpy);
  const priceJpySubTotal = priceJpyDecimal.times(itemInCart.amountToBuy).toNumber();


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <div className='flexRow justifyContentCenter alignItemsCenter boxShadow01 margin1'>
          <MerchandiseImage item={itemInCart.information} />
          <div className='flexColumn justifyContentFlexStart alignItemsCenter'>
            <MerchandiseName item={itemInCart.information} />
            <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
              <div>
                { words.unitPriceJpy[state.language] }
              </div>
              <div className='marginSide1' >
                { itemInCart.information.priceJpy.toLocaleString() }
              </div>
              <div>
                { words.yen[state.language] + words.taxIncluded[state.language] }
              </div>
            </div>
            <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
              <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
                <div>
                  { words.amountToBuy[state.language] }
                </div>
                <div className='marginSide1' >
                  { itemInCart.amountToBuy.toLocaleString() }
                </div>
                <div>
                  { words.ko[state.language] }
                </div>
              </div>
              <AddToCartButtons item={itemInCart.information} word='' />
            </div>
            <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
              <div>
                { words.subtotal[state.language] }
              </div>
              <div className='marginSide1'>
                { priceJpySubTotal.toLocaleString() }
              </div>
              <div>
                { words.yen[state.language] + words.taxIncluded[state.language] }
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="flexColumn visibleSmallOrLess ">
        <div className='flexColumn justifyContentFlexStart alignItemsCenter width96vw marginBottom2 boxShadow01'>
          <MerchandiseImage item={itemInCart.information} />
          <MerchandiseName item={itemInCart.information} />
          <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
            <div>
              { words.unitPriceJpy[state.language] }
            </div>
            <div className='marginSide1' >
              { itemInCart.information.priceJpy.toLocaleString() }
            </div>
            <div>
              { words.yen[state.language] + words.taxIncluded[state.language] }
            </div>
          </div>
          <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
            <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
              <div>
                { words.amountToBuy[state.language] }
              </div>
              <div className='marginSide1' >
                { itemInCart.amountToBuy.toLocaleString() }
              </div>
              <div>
                { words.ko[state.language] }
              </div>
            </div>
            <AddToCartButtons item={itemInCart.information} word='' />
          </div>
          <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
            <div>
              { words.subtotal[state.language] }
            </div>
            <div className='marginSide1'>
              { priceJpySubTotal.toLocaleString() }
            </div>
            <div>
              { words.yen[state.language] + words.taxIncluded[state.language] }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ADD TO CART BUTTONS
function AddToCartButtons(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const item = props.item;
  const word = props.word;

  return (
    <div className='flexRow justifyContentCenter alignItemsCenter '>
      <button className='button1' disabled={props.disabled ? true : false}
        onClick={ () => removeFromCart(state, dispatch, item) }
      >
        -
      </button>
      <div>
        { word }
      </div>
      <button className='button1' disabled={props.disabled ? true : false}
        onClick={ () => addToCart(state, dispatch, item) }
      >
        +
      </button>
    </div>
  );
}


// CHECK OUT
function CheckOut(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const keyPairsInPoolAll = useGlobalStateSelector( ({ state }) => state.keyPairs );
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);
  const location = useLocation();

  const itemsIncart = Object.values(state.checkout.itemsIncart).map( item => <MerchandiseInCart itemInCart={item} /> );

  const priceJpyTotal = Object.values(state.checkout.itemsIncart).reduce( (acc, cur) => acc + cur.information.priceJpy * cur.amountToBuy, 0);

  // 購入確定ボタン

  const submitButton =
    <div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
        onClick={ () => {
          const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: keyPairsInPoolAll });
          const keyPair = keyPairsInPool[state.checkout.addressMain]?.keyPair;

          handleClickSubmitOrder(state, dispatch, navigate, keyPair)
          .catch( () => {
            // 何もしない
          });
        }}
      >
        <div>
          { words.submitOrder[state.language] }
        </div>
        <div>
          <img className='size2x2' src={iconSign} alt='sign' />
        </div>
      </button>
    </div>;

  // 決済手段

  let paymentMethod;

  if (state.checkout.paymentMethod === 'bankTransfer') {
    paymentMethod =
    <div className='flexColumn alignItemsCenter ' >
      <div className='' >
        { words.bankTransfer[state.language] }
      </div>
    </div>;
  }
  else { // paygent
    paymentMethod =
    <div className='flexColumn alignItemsCenter ' >
      <div className='' >
        { words.paygent2[state.language] }
      </div>
      {/*
        <div className='colorRed marginTop0p5' >
          { words.underTesting[state.language] }
        </div>
      */}
    </div>;
  }

  // 注意書き

  let notes;

  if (state.checkout.paymentMethod === 'bankTransfer') {
    notes =
    <div className='flexColumn justifyContentFlexStart alignItemsFlexStart backgroundColorMonacottoAlmostWhite borderRadius0p3 padding1 marginTopBottom1 '>
      <div className='preWrap '>
        { state.config.clientParameters.itemSales.notes4 }
      </div>
      <div className='preWrap '>
        { state.config.clientParameters.itemSales.notes1 }
      </div>
      <div className='preWrap marginTopBottom1'>
        { state.config.clientParameters.itemSales.notes2 }
      </div>
      <div className='preWrap '>
        { state.config.clientParameters.itemSales.notes3 }
      </div>
    </div>;
  }
  else { // paygent
    notes =
    <div className='flexColumn justifyContentFlexStart alignItemsFlexStart backgroundColorMonacottoAlmostWhite borderRadius0p3 padding1 marginTopBottom1 '>
      <div className='preWrap '>
        { state.config.clientParameters.itemSales.notes4 }
      </div>
      <div className='preWrap '>
        { state.config.clientParameters.itemSales.notes3 }
      </div>
    </div>;
  }

  // メインアドレス入力セクション

  const mainAddressInputSection =
    <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
      <TextLine3 fieldName='checkoutAddressMain' keys={['checkout', 'addressMain']} face={words.addressMain[state.language]} tooltip={true} />
      <SelectSessionButton loginEnabled={true} />
    </div>

  const headerFixed =
  <div className='z200FixedZero widthMax backgroundColorWhiteTransparent '>
    <div className='flexRow justifyContentFlexEnd marginBottom1' >
      <button className='button2' onClick={ () => handleClickGoBack(state, dispatch, navigate, location) }>
        { words.back[state.language] }
      </button>
      <button className='button2' onClick={ () => handleClickGoTop(state, dispatch, navigate) }>
        top
      </button>
    </div>
  </div>;

  const headerRelative =
  <div className='widthMax height6 ' >
  </div>;


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore flexColumn alignItemsCenter">
        { headerRelative }
        <div className="flexColumn justifyContentFlexStart alignItemsCenter ">
          <div className='flexRow justifyContentFlexStart alignItemsCenter preWrap marginTop1 '>
            { words.purchasedItems[state.language] }
          </div>
          { itemsIncart }
        </div>
        {/* total price */}
        <div className='flexRow justifyContentFlexStart alignItemsCenter font2 marginTop1 '>
          { words.priceTotal[state.language] }
          <div className='marginSide1 '>
            { priceJpyTotal.toLocaleString() }
          </div>
          <div>
            { words.yen[state.language] + words.taxIncluded[state.language] }
          </div>
        </div>
        {/* main address */}
        <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
          { words.addressMain[state.language] }
          <div className='marginSide1 '>
            { state.checkout.addressMain }
          </div>
        </div>
        {/* payment method */}
        <div className='flexColumn justifyContentFlexStart alignItemsCenter marginTop1 '>
          <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
            { words.paymentMethod[state.language] }
            <div className='flexRow justifyContentSpaceAround '>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.checkout.paymentMethod === 'bankTransfer' ? 'colorRed borderSelected' : 'borderNone')}
                tabindex='0'
                onClick={ () => {
                  dispatch({type: 'setStateMultiLayers', keys: ['checkout', 'paymentMethod'], value: 'bankTransfer'});
                }}
              >
                <div>
                  {words.bankTransfer[state.language]}
                </div>
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.checkout.paymentMethod === 'paygent' ? 'colorRed borderSelected' : 'borderNone')}
                tabindex='0'
                onClick={ () => {
                  dispatch({type: 'setStateMultiLayers', keys: ['checkout', 'paymentMethod'], value: 'paygent'});
                }}
              >
                <div>
                  {words.paygent[state.language]}
                </div>
              </button>
            </div>
          </div>
          { paymentMethod }
        </div>
        {/* notes */}
        { notes }
        {/* mail address */}
        <div className='flexColumn alignItemsCenter marginTopBottom1 '>
          <div className='flexRow justifyContentFlexStart alignItemsCenter preWrap '>
            { state.config.clientParameters.itemSales.fillInYourEMailAddress }
          </div>
          <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
            <TextLine3 fieldName='mailAddress' keys={['checkout', 'mailAddress']} face={words.mailAddress[state.language]} tooltip={true} />
          </div>
        </div>
        <div className='flexColumn alignItemsFlexStart margin1'>
          <div >
            { words.pleaseLoginWithMainAddressInAdvance[state.language] }
          </div>
          <div >
            { words.whenUsingMpurseEtcAfterClickingTheButtonPleaseSignInThePopup[state.language] }
          </div>
        </div>
        {/* main address */}
        { mainAddressInputSection }
        {/* submit */}
        <div className='flexColumn alignItemsCenter marginTopBottom1 '>
          {/*
            <div className='flexRow justifyContentFlexStart alignItemsCenter preWrap '>
              { state.config.clientParameters.itemSales.signAfterClickPurchase[state.walletType] }
            </div>
          */}
          { submitButton }
        </div>
      </div>
      {/* SP */}
      <div className="flexColumn alignItemsCenter visibleSmallOrLess ">
        { headerRelative }
        <div className="flexColumn justifyContentFlexStart alignItemsCenter ">
          <div className='flexRow justifyContentFlexStart alignItemsCenter preWrap marginTop1 '>
            { words.purchasedItems[state.language] }
          </div>
          { itemsIncart }
        </div>
        {/* total price */}
        <div className='flexColumn alignItemsCenter marginTop1 '>
          <div className='font2'>
            { words.priceTotal[state.language] }
          </div>
          <div className='flexRow justifyContentFlexStart alignItemsCenter font2 '>
            <div className='marginSide0p5 '>
              { priceJpyTotal.toLocaleString() }
            </div>
            <div>
              { words.yen[state.language] + words.taxIncluded[state.language] }
            </div>
          </div>
        </div>
        {/* main address */}
        <div className='flexColumn alignItemsCenter marginTop1 '>
          <div className=''>
            { words.addressMain[state.language] }
          </div>
          <div className=''>
            { state.checkout.addressMain }
          </div>
        </div>
        {/* payment method */}
        <div className='flexColumn justifyContentFlexStart alignItemsCenter marginTop1 '>
          { words.paymentMethod[state.language] }
          <div className='flexRow justifyContentSpaceAround '>
            <button className={'box3 focusEffect01 riseOut2 ' + (state.checkout.paymentMethod === 'bankTransfer' ? 'colorRed borderSelected' : 'borderNone')}
              tabindex='0'
              onClick={ () => {
                dispatch({type: 'setStateMultiLayers', keys: ['checkout', 'paymentMethod'], value: 'bankTransfer'});
              }}
            >
              <div>
                {words.bankTransfer[state.language]}
              </div>
            </button>
            <button className={'box3 focusEffect01 riseOut2 ' + (state.checkout.paymentMethod === 'paygent' ? 'colorRed borderSelected' : 'borderNone')}
              tabindex='0'
              onClick={ () => {
                dispatch({type: 'setStateMultiLayers', keys: ['checkout', 'paymentMethod'], value: 'paygent'});
              }}
            >
              <div>
                {words.paygent[state.language]}
              </div>
            </button>
          </div>
          { paymentMethod }
        </div>
        {/* notes */}
        { notes }
        {/* mail address */}
        <div className='flexColumn alignItemsCenter marginTopBottom1 '>
          <div className='flexRow justifyContentFlexStart alignItemsCenter preWrap '>
            { state.config.clientParameters.itemSales.fillInYourEMailAddress }
          </div>
          <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
            <TextLine3 fieldName='mailAddress' keys={['checkout', 'mailAddress']} face={words.mailAddress[state.language]} tooltip={true} />
          </div>
        </div>
        <div className='flexColumn alignItemsFlexStart margin1'>
          <div >
            { words.pleaseLoginWithMainAddressInAdvance[state.language] }
          </div>
          <div >
            { words.whenUsingMpurseEtcAfterClickingTheButtonPleaseSignInThePopup[state.language] }
          </div>
        </div>
        {/* main address */}
        { mainAddressInputSection }
        {/* submit */}
        <div className='flexColumn alignItemsCenter marginTopBottom1 '>
          {/*
            <div className='flexRow justifyContentFlexStart alignItemsCenter preWrap marginBottom1'>
              { state.config.clientParameters.itemSales.signAfterClickPurchase[state.walletType] }
            </div>
          */}
          { submitButton }
        </div>
      </div>
      { headerFixed }
    </div>
  );
}

// ITEM ORDER HISTORY
function ItemOrderHistory(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);
  const location = useLocation();
  let historyItems;
  let historyFunction;
  let arrowLeft;
  let arrowRight;

  useEffect( () => {
    const activeCertification = location?.state?.activeCertification;
    // const func = async () => {
      if (
        state.getItemOrderHistory.addressMain !== undefined && state.getItemOrderHistory.addressMain !== null && state.getItemOrderHistory.addressMain !== ''
        // state.itemOrderHistory[state.getItemOrderHistory.addressMain]?.itemOrder === undefined
      ) {
        let request;
        if (activeCertification !== undefined && activeCertification !== null) {
          request = handleClickGetItemOrderHistory(state, dispatch, 0, activeCertification);
        }
        else {
          request = handleClickGetItemOrderHistory(state, dispatch, 0);
        }
        request.catch( () => {
          // 何もしない
        });
      }
    // };

    // func();
  }, []);

  // アクションごとのhistoryItemsとhistoryFunction設定。

  if (state.getItemOrderHistory.action === 'itemOrder') {
    if (state.itemOrderHistory[state.getItemOrderHistory.addressMain]?.itemOrder !== undefined) {
      historyItems = state.itemOrderHistory[state.getItemOrderHistory.addressMain].itemOrder
      .filter( record => record.purchaseItemNo !== 0 )
      .map( record => <ItemOrderHistoryRecord record={record} /> );

      historyItems.unshift(<ItemOrderHistoryRecordTitle />);
    }
    else {
      historyItems = [<ItemOrderHistoryRecordTitle />];
    }

    historyFunction = async (pagingIndex) => {
      handleClickGetItemOrderHistory(state, dispatch, pagingIndex)
      .catch( () => {
          // 何もしない
      });
    };
  }

  // 矢印

  if ( state.getItemOrderHistory.pagingIndex[state.getItemOrderHistory.action] >= 1 ) {
    arrowLeft = <div>
      <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large backgroundColorTransparent borderNone cursor borderRadiusCircle riseOut2 '
        onClick={ () => historyFunction(state.getItemOrderHistory.pagingIndex[state.getItemOrderHistory.action] - 1) }
      >
        <img className='size2x2' src={iconCircleLeft} alt='' />
      </button>
    </div>
  }
  else {
    arrowLeft = <div>
      <button className='size2x2Large backgroundColorTransparent borderNone' disabled={true} >
        <div className='size2x2' />
      </button>
    </div>
  }

  if ( state.getItemOrderHistory.lastEvaluatedKey[state.getItemOrderHistory.action][state.getItemOrderHistory.pagingIndex[state.getItemOrderHistory.action]] !== undefined &&
       state.getItemOrderHistory.lastEvaluatedKey[state.getItemOrderHistory.action][state.getItemOrderHistory.pagingIndex[state.getItemOrderHistory.action]] !== null ) {
    arrowRight = <div>
      <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large backgroundColorTransparent borderNone cursor borderRadiusCircle riseOut2 '
        onClick={ () => { historyFunction(state.getItemOrderHistory.pagingIndex[state.getItemOrderHistory.action] + 1) } }
      >
        <img className='size2x2' src={iconCircleRight} alt='' />
      </button>
    </div>
  }
  else {
    arrowRight = <div>
      <button className='size2x2Large backgroundColorTransparent borderNone' disabled={true} >
        <div className='size2x2' />
      </button>
    </div>
  }

  // 商品購入履歴コントロールセクション

  const controlSection =
    <div>
      <div className='visibleMiddleOrMore flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
        {/* addressMain */}
        <TextLine3 fieldName='itemOrderHistoryAddressMain' keys={['getItemOrderHistory', 'addressMain']} face={words.addressMain[state.language]} tooltip={true}
          extraFunctionOnChange={ [
            {
              function: () => {
                dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'pagingIndex'],
                  value: { itemOrder: 0 }
                });
                dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'lastEvaluatedKey'],
                  value: { itemOrder: [] }
                });
              },
              arguments: [],
            }
          ]}
        />
        <SelectSessionButton stateKeysToSetAddress={[['getItemOrderHistory', 'addressMain']]} stateKeysToSetUserName={[]} loginEnabled={false}
          extraFunction={ () => {
            dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'pagingIndex'],
              value: { itemOrder: 0 }
            });
            dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'lastEvaluatedKey'],
              value: { itemOrder: [] }
            });
          }}
        />
        <button className='button1' tabindex='0' onClick={ () => historyFunction(0) } >
          <img className='size2x2' src={iconSearch} alt='' />
        </button>
        { arrowLeft }
        { arrowRight }
      </div>
      <div className="visibleSmallOrLess flexColumn">
        {/* addressMain */}
        <TextLine3 fieldName='historyAddressMain' keys={['getItemOrderHistory', 'addressMain']} face={words.addressMain[state.language]} tooltip={true}
          extraFunctionOnChange={ [
            {
              function: () => {
                dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'pagingIndex'],
                  value: { itemOrder: 0 }
                });
                dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'lastEvaluatedKey'],
                  value: { itemOrder: [] }
                });
              },
              arguments: [],
            }
          ]}
        />
        <SelectSessionButton stateKeysToSetAddress={[['getItemOrderHistory', 'addressMain']]} stateKeysToSetUserName={[]} loginEnabled={false}
          extraFunction={ () => {
            dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'pagingIndex'],
              value: { itemOrder: 0 }
            });
            dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'lastEvaluatedKey'],
              value: { itemOrder: [] }
            });
          }}
        />
        <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax '>
          <button className='button1' tabindex='0' onClick={ () => historyFunction(0) } >
            <img className='size2x2' src={iconSearch} alt='' />
          </button>
          <div className='flexRow'>
            <div className='marginSide0p5'>
              { arrowLeft }
            </div>
            <div className='marginSide0p5'>
              { arrowRight }
            </div>
          </div>
        </div>
      </div>
    </div>;

  // if (state.walletType === 'mpurse') {
  //   controlSection =
  //   <div>
  //     <div className='visibleMiddleOrMore flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
  //       {/* addressMain */}
  //       <TextLine3 fieldName='itemOrderHistoryAddressMain' keys={['getItemOrderHistory', 'addressMain']} face={words.addressMain[state.language]} tooltip={true}
  //         extraFunctionOnChange={ [
  //           {
  //             function: () => {
  //               dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'pagingIndex'],
  //                 value: { itemOrder: 0 }
  //               });
  //               dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'lastEvaluatedKey'],
  //                 value: { itemOrder: [] }
  //               });
  //             },
  //             arguments: [],
  //           }
  //         ]}
  //       />
  //       <button className='button1'
  //         onClick={ () => {
  //           handleClickMpurse(state, dispatch, ['getItemOrderHistory', 'addressMain']);
  //           dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'pagingIndex'],
  //             value: { itemOrder: 0 }
  //           });
  //           dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'lastEvaluatedKey'],
  //             value: { itemOrder: [] }
  //           });
  //         }}
  //       >
  //         <img className='size2x2' src={iconMpurse} alt='' />
  //       </button>
  //       <button className='button1' tabindex='0' onClick={ () => historyFunction(0) } >
  //         <img className='size2x2' src={iconSearch} alt='' />
  //       </button>
  //       { arrowLeft }
  //       { arrowRight }
  //     </div>
  //     <div className="visibleSmallOrLess flexColumn">
  //       {/* addressMain */}
  //       <TextLine3 fieldName='historyAddressMain' keys={['getItemOrderHistory', 'addressMain']} face={words.addressMain[state.language]} tooltip={true}
  //         extraFunctionOnChange={ [
  //           {
  //             function: () => {
  //               dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'pagingIndex'],
  //                 value: { itemOrder: 0 }
  //               });
  //               dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'lastEvaluatedKey'],
  //                 value: { itemOrder: [] }
  //               });
  //             },
  //             arguments: [],
  //           }
  //         ]}
  //       />
  //       <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax '>
  //         <div className='flexRow'>
  //           <button className='button1'
  //             onClick={ () => {
  //               handleClickMpurse(state, dispatch, ['getItemOrderHistory', 'addressMain']);
  //               dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'pagingIndex'],
  //                 value: { itemOrder: 0 }
  //               });
  //               dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'lastEvaluatedKey'],
  //                 value: { itemOrder: [] }
  //               });
  //             }}
  //           >
  //             <img className='size2x2' src={iconMpurse} alt='' />
  //           </button>
  //           <button className='button1' tabindex='0' onClick={ () => historyFunction(0) } >
  //             <img className='size2x2' src={iconSearch} alt='' />
  //           </button>
  //         </div>
  //         <div className='flexRow'>
  //           <div className='marginSide0p5'>
  //             { arrowLeft }
  //           </div>
  //           <div className='marginSide0p5'>
  //             { arrowRight }
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>;
  // }
  // else {
  //   controlSection =
  //   <div>
  //     <div className='visibleMiddleOrMore flexRow justifyContentFlexStart alignItemsCenter '>
  //       <div className='flexRow'>
  //         <button className='button1' tabindex='0' onClick={ () => historyFunction(0) } >
  //           <img className='size2x2' src={iconSearch} alt='' />
  //         </button>
  //       </div>
  //       <div className='flexRow'>
  //         <div className='marginSide0p5'>
  //           { arrowLeft }
  //         </div>
  //         <div className='marginSide0p5'>
  //           { arrowRight }
  //         </div>
  //       </div>
  //     </div>
  //     <div className='visibleSmallOrLess flexRow justifyContentSpaceBetween alignItemsCenter widthMax '>
  //       <div className='flexRow'>
  //         <button className='button1' tabindex='0' onClick={ () => historyFunction(0) } >
  //           <img className='size2x2' src={iconSearch} alt='' />
  //         </button>
  //       </div>
  //       <div className='flexRow'>
  //         <div className='marginSide0p5'>
  //           { arrowLeft }
  //         </div>
  //         <div className='marginSide0p5'>
  //           { arrowRight }
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // }

  const headerFixed =
  <div className='z200FixedZero widthMax backgroundColorWhiteTransparent '>
    <div className='flexRow justifyContentFlexEnd marginBottom1' >
      <button className='button2' onClick={ () => handleClickGoTop(state, dispatch, navigate) }>
        { words.back[state.language] }
      </button>
    </div>
  </div>;

  const headerRelative =
  <div className='widthMax height6 ' >
  </div>;


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <div className='flexColumn'>
          { headerRelative }
          {/* history */}
          { controlSection }
          { historyItems }
          {/* development */}
          <div>
            { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn">
        { headerRelative }
        {/* history */}
        { controlSection }
        { historyItems }
      </div>
      { headerFixed }
    </div>
  );
}

// ITEM ORDER HISTORY RECORD TITLE
function ItemOrderHistoryRecordTitle() {
  const state = useGlobalStateSelector(({ state }) => state);

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { words.purchaseItemNo[state.language] }
          </div>
          <div className='marginSide1 widthMin25' >
            { words.item[state.language] }
          </div>
          <div className='marginSide1 widthMin12 ' >
            { words.priceTotal[state.language] + words.taxIncluded[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.purchaseTime[state.language] }
          </div>
          <div className='marginSide1 widthMin10' >
            { words.status[state.language] }
          </div>
          <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite' disabled={true} />
        </div>
      </div>
      {/* SP */}
    </div>
  );
}

// ITEM ORDER HISTORY RECORD
function ItemOrderHistoryRecord(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const record = props.record;
  const item0 = record.items[0];

  const popup = { type: 'itemOrderHistoryRecordDetail', body: record };

  const buttons =
  <button className='button1' onClick={ () => { dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup }) } } >
    <img className='size2x2' src={iconDetail} alt='detail' />
  </button>;

  // 購入商品が複数あった場合。

  let etc = '';

  if (record.items.length >= 2) {
    etc = ' ...';
  }


  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { 'No. ' + record.purchaseItemNo.toLocaleString() }
          </div>
          <div className='marginSide1 widthMin25' >
            { item0.information.name + etc }
          </div>
          <div className='flexRow justifyContentCenter alignItemsCenter marginSide1 widthMin12 ' >
            <div className='paddingRight1'>
              { record.priceJpyTotal.toLocaleString() }
            </div>
            <div>
              { words.yen[state.language] }
            </div>
          </div>
          <div className='marginSide1 widthMin15' >
            { localTime(record.serverTimeOfAddressMain, 'yearToSecond') }
          </div>
          <div className='marginSide1 widthMin10' >
            { words[record.status][state.language] }
          </div>
          { buttons }
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='boxMonacotto1SmallScreen flexColumn alignItemsFlexStart '  >
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.purchaseItemNo[state.language] }
            </div>
            <div className='flexRow alignItemsCenter' >
              <div>
                { 'No. ' + record.purchaseItemNo.toLocaleString() }
              </div>
              { buttons }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.item[state.language] }
            </div>
            <div className='' >
              { item0.information.name + etc }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.priceTotal[state.language] + words.taxIncluded[state.language] }
            </div>
            <div className='flexRow alignItemsCenter' >
              <div className='paddingRight1'>
                { record.priceJpyTotal.toLocaleString() }
              </div>
              <div>
                { words.yen[state.language] }
              </div>
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.purchaseTime[state.language] }
            </div>
            <div className='' >
              { localTime(record.serverTimeOfAddressMain, 'yearToSecond') }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.status[state.language] }
            </div>
            <div className='' >
              { words[record.status][state.language] }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ITEM ORDER HISTORY RECORD DETAIL
function ItemOrderHistoryRecordDetail(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const popupLayer = props.popupLayer;
  const record = state.popup[popupLayer].body;

  const items = record.items.map( item => <MerchandiseInHistory itemInCart={item} popupLayer={popupLayer} /> );

  let sendTokenTxids;

  if (record.sendTokenTxid !== undefined) {
    sendTokenTxids = record.sendTokenTxid.map( txid =>
      <div className='paddingLeft1'>
        {txid}
      </div>
    );
  }


  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressMain[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressMain}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.purchaseItemNo[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.purchaseItemNo.toLocaleString()}
          </div>
        </div>
        { items }
        <div className='flexColumn boxDetail'>
          <div>
            {words.priceTotal[state.language]}
          </div>
          <div className='flexRow justifyContentFlexStart alignItemsCenter padding0p5 '>
            <div className='paddingSide1'>
              {record.priceJpyTotal.toLocaleString()}
            </div>
            <div>
              { words.yen[state.language] + words.taxIncluded[state.language] }
            </div>
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.status[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[record.status][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.purchaseIdentifier[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.purchaseIdentifier}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.purchaseTime[state.language]}
          </div>
          <div className='paddingLeft1'>
            {localTime(record.serverTimeOfAddressMain, 'yearToSecond')}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.extraMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.extraMona}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.sendTokenTxid[state.language]}
          </div>
          { sendTokenTxids }
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.sendMonaTxid[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.sendMonaTxid}
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='flexColumn alignItemsCenter'>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressMain[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressMain}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.purchaseItemNo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.purchaseItemNo.toLocaleString()}
            </div>
          </div>
          { items }
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.priceTotal[state.language]}
            </div>
            <div className='flexRow alignItemsCenter'>
              <div className='paddingSide1'>
                {record.priceJpyTotal.toLocaleString()}
              </div>
              <div>
                { words.yen[state.language] + words.taxIncluded[state.language] }
              </div>
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.status[state.language]}
            </div>
            <div className='paddingLeft1'>
              {words[record.status][state.language]}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.purchaseIdentifier[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.purchaseIdentifier}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.purchaseTime[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.serverTimeOfAddressMain, 'yearToSecond')}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.extraMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.extraMona}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.sendTokenTxid[state.language]}
            </div>
            { sendTokenTxids }
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.sendMonaTxid[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.sendMonaTxid}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// MERCHANDISE IN HISTORY
function MerchandiseInHistory(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const itemInCart = props.itemInCart;
  const popupLayer = props.popupLayer;


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <div className='flexRow justifyContentCenter alignItemsCenter boxShadow01 margin1'>
          <MerchandiseImage item={itemInCart.information} popupLayer={popupLayer} />
          <div className='flexColumn justifyContentFlexStart alignItemsCenter'>
            <MerchandiseName item={itemInCart.information} popupLayer={popupLayer} />
            <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
              <div>
                { words.unitPriceJpy[state.language] }
              </div>
              <div className='marginSide1'>
                { itemInCart.information.priceJpy.toLocaleString() }
              </div>
              <div>
                { words.yen[state.language] + words.taxIncluded[state.language] }
              </div>
            </div>
            <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
              <div>
                { words.amountToBuy[state.language] }
              </div>
              <div className='marginSide1'>
                { itemInCart.amountToBuy.toLocaleString() }
              </div>
              <div>
                { words.ko[state.language] }
              </div>
            </div>
            <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
              <div>
                { words.subtotal[state.language] }
              </div>
              <div className='marginSide1'>
                { itemInCart.priceJpySubTotal.toLocaleString() }
              </div>
              <div>
                { words.yen[state.language] + words.taxIncluded[state.language] }
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess ">
        <div className='flexColumn justifyContentFlexStart alignItemsCenter width96vw marginBottom2 boxShadow01'>
          <MerchandiseImage item={itemInCart.information} popupLayer={popupLayer} />
          <MerchandiseName item={itemInCart.information} popupLayer={popupLayer} />
          <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
            <div>
              { words.unitPriceJpy[state.language] }
            </div>
            <div className='marginSide1'>
              { itemInCart.information.priceJpy.toLocaleString() }
            </div>
            <div>
              { words.yen[state.language] + words.taxIncluded[state.language] }
            </div>
          </div>
          <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
            <div>
              { words.amountToBuy[state.language] }
            </div>
            <div className='marginSide1'>
              { itemInCart.amountToBuy.toLocaleString() }
            </div>
            <div>
              { words.ko[state.language] }
            </div>
          </div>
          <div className='flexRow justifyContentCenter alignItemsCenter padding0p5 '>
            <div>
              { words.subtotal[state.language] }
            </div>
            <div className='marginSide1'>
              { itemInCart.priceJpySubTotal.toLocaleString() }
            </div>
            <div>
              { words.yen[state.language] + words.taxIncluded[state.language] }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export {
  PurchaseItem,
  MerchandiseDetail,
  CheckOut,
  ItemOrderHistory,
  ItemOrderHistoryRecordDetail,
}